// src/pages/Contact.jsx
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { urlMap } from '../utils';
import Footer from './components/Footer';
import '../assets/styles/Contact.css';

class Contact extends Component {
  state = {
    name:    '',
    email:   '',
    subject: '',
    message: '',
    status:  null,   // { type: 'ok' | 'err', text: string } | null
    loading: false,
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value, status: null });
  };

  validate() {
    const { name, email, message } = this.state;
    if (!name.trim())    return 'Please enter your name.';
    if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
      return 'Please enter a valid email address.';
    }
    if (!message.trim()) return 'Please enter a message.';
    return null;
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    const validationError = this.validate();
    if (validationError) {
      this.setState({ status: { type: 'err', text: validationError } });
      return;
    }

    this.setState({ loading: true, status: null });
    const { name, email, subject, message } = this.state;

    try {
      const res  = await fetch(urlMap.contact, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ name: name.trim(), email: email.trim(), subject: subject.trim(), message: message.trim() }),
      });
      const data = await res.json().catch(() => ({}));

      if (res.ok && data.success) {
        this.setState({
          name: '', email: '', subject: '', message: '',
          status: { type: 'ok', text: "Thanks! Your message has been sent. We'll get back to you soon." },
        });
      } else {
        const msg = data.error === 'INVALID_EMAIL'
          ? 'Please enter a valid email address.'
          : (data.message || 'Something went wrong. Please try again.');
        this.setState({ status: { type: 'err', text: msg } });
      }
    } catch {
      this.setState({ status: { type: 'err', text: 'Network error. Please check your connection and try again.' } });
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { name, email, subject, message, status, loading } = this.state;

    return (
      <div className="contact-page">
        <header className="contact-topbar" role="banner">
          <a href="https://storyclub.ai" className="contact-back-link" rel="noopener noreferrer">
            ← storyclub.ai
          </a>
          <div className="contact-topbar-right">
            <Link to="/login" className="contact-signin-link">Sign in</Link>
          </div>
        </header>

        <main className="contact-wrapper">
          <form className="contact-form" onSubmit={this.handleSubmit} noValidate>
            <h2>Contact us</h2>
            <p className="subtitle">Questions or feedback? Drop us a message.</p>

            <div className="contact-row">
              <div className="contact-field">
                <label htmlFor="cf-name">Name</label>
                <input
                  id="cf-name" name="name" type="text"
                  placeholder="Your name"
                  value={name} onChange={this.handleChange} required
                />
              </div>
              <div className="contact-field">
                <label htmlFor="cf-email">Email</label>
                <input
                  id="cf-email" name="email" type="email"
                  placeholder="you@example.com"
                  value={email} onChange={this.handleChange} required
                />
              </div>
            </div>

            <div className="contact-field">
              <label htmlFor="cf-subject">
                Subject <span className="optional">(optional)</span>
              </label>
              <input
                id="cf-subject" name="subject" type="text"
                placeholder="What's it about?"
                value={subject} onChange={this.handleChange}
              />
            </div>

            <div className="contact-field">
              <label htmlFor="cf-message">Message</label>
              <textarea
                id="cf-message" name="message"
                placeholder="Your message…"
                rows={5}
                value={message} onChange={this.handleChange} required
              />
            </div>

            {status && (
              <p className={`contact-status contact-status--${status.type}`} role="alert">
                {status.text}
              </p>
            )}

            <button type="submit" disabled={loading}>
              {loading ? 'Sending…' : 'Send message'}
            </button>
          </form>
        </main>

        <Footer />
      </div>
    );
  }
}

export default Contact;
